const $ = jQuery.noConflict();
import Global from '../shared/global';

'use strict';
const Menu = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domMenuBtn: $('.js-menu-btn'),
	$domMenuOuter: $('.js-nav-outer'),
	$domMenuInner: $('.js-nav-inner'),
	$domMenuIcon: $('.js-nav-icon'),
	$domMenuSub: $('.sub-menu'),
	$domHeader: $('.js-site-header'),
	$domMeniItem: $('.menu-item'),
	classHeaderScroll: 'site-header--scroll',
	slMenuIcon: '.js-nav-icon',
	slMenuSub: '.sub-menu',
	classActive: 'is-active',
	timeout: null,

	/** @description Initialize */
	init: function() {
		this.bindEvents();

		// header on scroll
		if (window.innerWidth < 550) {
			$(document).on('scroll', function() {
				const scrollTop = $(document).scrollTop();
				if (scrollTop > 20) {
					Menu.$domHeader.addClass(Menu.classHeaderScroll);
				} else {
					Menu.$domHeader.removeClass(Menu.classHeaderScroll);
				}
			});
			const height = $(window).scrollTop();
			if(height > 30) {
				Menu.$domHeader.addClass(Menu.classHeaderScroll);
			}
		}

		$('.js-learning-dropbtn').on('click', function() {
			$('.js-learning-dropdown-content').addClass('show');
			$('.js-learning-dropbtn').addClass('active');
			// $('.js-learning-overlay').addClass('active');
		});

		$('.js-learning-overlay').on('click', function() {
			$('.js-learning-dropdown-content').removeClass('show');
			$('.js-learning-dropbtn').removeClass('active');
			// $('.js-learning-overlay').removeClass('active');
		});

		window.addEventListener('mouseup', function(event) {
			const pol = document.getElementById('polearningDropdownl');
			if(event.target !== pol && event.target.parentNode !== pol){
				$('.js-learning-dropdown-content').removeClass('show');
				$('.js-learning-dropbtn').removeClass('active');
			}
		});

		if (window.innerWidth > 551) {
			$(document).on('scroll', function() {
				const scrollTop = $(document).scrollTop();
				if (scrollTop > 20) {
					Menu.$domHeader.addClass(Menu.classHeaderScroll);
				} else {
					Menu.$domHeader.removeClass(Menu.classHeaderScroll);
				}
			});
			const height = $(window).scrollTop();
			if(height > 52) {
				Menu.$domHeader.addClass(Menu.classHeaderScroll);
			}
		}

		// $('.menu-item').on('click', function() {
		// 	$(this).parent().parent().parent().parent().removeClass('is-active');
		// 	$(this).parent().parent().parent().parent().parent().parent().next().removeClass('is-active');
		// });
	},

	/** @description Bind Events */
	bindEvents: function() {
		this.$domMenuBtn.on('click', this.toggleMenu.bind(this));
		this.$domMenuIcon.on('click', this.toggleSubMenu.bind(this));
		Global.escKey(this.closeMenu.bind(this));
		Global.clickOutsideContainer(Global.$domBody, this.$domMenuInner, this.$domMenuBtn, this.closeMenu.bind(this));
	},

	toggleMenu: function() {
		if (!this.$domMenuBtn.hasClass(this.classActive)) {
			this.$domMenuBtn.addClass(this.classActive);
			this.$domMenuOuter.addClass(this.classActive);
		} else {
			this.closeMenu();
		}
	},

	toggleSubMenu(e) {
		const icon = $(e.target).closest(this.slMenuIcon);
		const ul = icon.siblings(this.slMenuSub);

		if (!icon.hasClass(this.classActive)) {
			icon.addClass(this.classActive);
			ul.slideDown();
		} else {
			icon.removeClass(this.classActive);
			icon.parent().find(this.slMenuIcon).removeClass(this.classActive);
			ul.slideUp();
			ul.find(this.slMenuSub).slideUp();
		}
	},

	closeMenu: function() {
		this.$domMenuBtn.removeClass(this.classActive);
		this.$domMenuOuter.removeClass(this.classActive);

		// timeout should match the selectors CSS transition duration property
		clearTimeout(this.timeout);
		this.timeout = setTimeout(() => {
			this.$domMenuIcon.removeClass(this.classActive);
			this.$domMenuSub.slideUp();
		}, 500);
	}
};

export default Menu;
